import React, { useEffect } from "react";

// Patch all YouTube iframes in the DOM to include referrerpolicy attribute
function YouTubePatcher({ children }) {
  useEffect(() => {
    // Find all iframes on the page
    const iframes = document.querySelectorAll('iframe[src*="youtube.com"]');

    iframes.forEach((iframe) => {
      // Only patch if it doesn't already have referrerpolicy
      if (!iframe.hasAttribute('referrerpolicy')) {
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      }
    });
  });

  return <>{children}</>;
}

export const wrapPageElement = ({ element }) => {
  return <YouTubePatcher>{element}</YouTubePatcher>;
};
